export const REBRAND_LE_TOUR_LOGO_ID = 'luxuryescapes-tours-teal-logo'
export const LEGACY_LE_TOURS_OPERATOR_NAME = 'Luxury Escapes Tours'
export const REBRAND_LE_TOURS_OPERATOR_NAME = 'Luxury Escapes'

const LEGACY_LE_TOUR_LOGO_IDS = new Set([
  'le-tours-logo',
  'le-trusted-partner-tours-logo',
  'insider-series-logo',
  'pwvc4iibft4bm3q69fu9',
  'le-signature-tours-logo',
])

export function getTourV2OperatorLogoId(
  logoId: string | undefined,
  isRebrandEnabled: boolean,
): string | undefined {
  if (!logoId) {
    return logoId
  }

  if (isRebrandEnabled && LEGACY_LE_TOUR_LOGO_IDS.has(logoId)) {
    return REBRAND_LE_TOUR_LOGO_ID
  }

  return logoId
}

export function getTourV2OperatorDisplayName(
  operatorName: string | undefined,
  isRebrandEnabled: boolean,
): string | undefined {
  if (isRebrandEnabled && operatorName === LEGACY_LE_TOURS_OPERATOR_NAME) {
    return REBRAND_LE_TOURS_OPERATOR_NAME
  }

  return operatorName
}
